import API from "@fetcher/fetcher";

import type IBlogPost from "@api/models/IBlog";

import type IPaginatedResponse from "@fetcher/models/IPaginatedResponse";
import type IPagination from "@fetcher/models/IPagination";
import type { IResponse } from "@fetcher/models/IResponse";

const BASE_URL = "/blog-posts";

class BlogPostAPI {
  static getBlogPosts = (
    page = 1,
    perPage = 10,
  ): Promise<IPaginatedResponse<IBlogPost>> => {
    return API.get<IPagination<IBlogPost>>(BASE_URL, { page, perPage });
  };

  static getBlogPostBySlug = (slug: string): Promise<IResponse<IBlogPost>> => {
    return API.get<IBlogPost>(`${BASE_URL}/${slug}`, {});
  };

  static getRecentBlogPosts = (): Promise<IResponse<IBlogPost[]>> => {
    return API.get<IBlogPost[]>(`${BASE_URL}/recent`, {});
  };
}

export default BlogPostAPI;
